// supabase.js — zentraler Supabase-Client.
//
// Die App läuft in zwei Modi:
//  - DEMO-Modus (keine Env-Variablen gesetzt): alles wie bisher über
//    localStorage, Login akzeptiert jede Eingabe. supabase ist null.
//  - LIVE-Modus (REACT_APP_SUPABASE_URL + REACT_APP_SUPABASE_ANON_KEY gesetzt):
//    echte Authentifizierung und Postgres mit Row-Level-Security.
//
// Env-Variablen lokal in .env.local, auf Render unter Environment setzen.
import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anonKey);

export const supabase = isSupabaseConfigured ? createClient(url, anonKey) : null;
export const supabaseUrl = url || "";
